'use strict';

var $    					= require('jquery');
var Core 					= require('../core/core.js');

/**
 * Creates an colorswatch div. made to be used inside the inspector.
 * make sure to populate with color items
 *
 * @class
 */

class InspectorColorSwatch extends Core {

	_defaults() {
		return {
			target: '.js-editor',
			fields: {
        'color': '#000000'
      }
		};
	}

	constructor(options) {
		super(options);

//COLOR SHOULD BE A TRUSTED VALUE
		this.template = `
      <div class="editor__inspector__colorswatch js-inspector__colorswatch" style="background-color:<%= color %>;" data-color="<%= color %>"></div>
		`;

		super.render();

    $(this.$el).on('click', this._selectSwatch);

	}

  _selectSwatch(e) {
    e.preventDefault();
		$(e.currentTarget).trigger('Cioui:Inspector:click', e);

    //Remove selected class from any other swatch then add to target
    $('.js-inspector__colorswatch').removeClass('editor__inspector__colorswatch--selected');
    $(e.currentTarget).addClass('editor__inspector__colorswatch--selected');
  }

}
module.exports = InspectorColorSwatch;
